import React, {
  useState,
  useEffect,
  useRef
} from 'react';
import Cookies from 'js-cookie';
import './Cancel.css';

import { Footer } from "../../components/footer/footer";
import Googleadshorizontal from "../../components/google-AdSense/Googleadshorizontal";
import Navbarr from "../../components/header/Navbarr";
import ScrollButton from "../../components/scrollbutton/ScrollButton";
import Subheader from "../../components/subheader/Subheader";
import SubscribeButton from '../../components/subscribe/SubscribeButton';

import { Errormsg } from '../../components/tostifymsg/Errrormsg';
import { Succesmsg } from '../../components/tostifymsg/Succesmsg';

import { ReactComponent as ICONCancel } from "../../assets/cancel.svg";

function Cancel() {

  return (<div>
    <Navbarr/>

    <div className="after-nav-dsubheader containers con_div">
      <Googleadshorizontal props="mt-2 mb-2 text-center"/>
      <Subheader />
      
      <div className='h-100 min-vh-100'>
        <h1 className='mt-5 text-white fw-bold text-center'>
          Cancel Subscription
        </h1>

        <div className="d-flex gap-5 justify-content-center flex-wrap mt-5 mb-5">
          <ICONCancel className='w-icon'/>
        </div>
      </div>
    </div>

    <Footer />
    <ScrollButton />
  </div>);
}

export default Cancel;